<template>
  <div class="top-content lili-flex align-center space-between">
    <span @click="$router.push('/')" class="main-logo" />
    <div class="progress-wrapper lili-flex align-center">
      <span
        v-bind:style="{ width: this.$store.getters['ob/getProgFillWidth'] }"
        class="progress-fill"
      />
    </div>
    <span
      v-if="isGoBack && !$store.state.editMode"
      @click="handlRouterBack"
      class="go-back"
      id="back"
    />
    <div class="top-spacer"></div>
  </div>
</template>
<script>
export default {
  name: 'TopContent',
  props: ['isGoBack'],
  mounted () {
    window.addEventListener('keypress', (e) => {
      if (e && e.key === 'Enter') {
        // Prevent from the form to refresh the page then submiting.
        e.preventDefault()
        this.$emit('callSubmit')
      }
    })
  },
  methods: {
    handlRouterBack () {
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
.top-spacer {
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translate(-6%, 15.5px);
  width: 100vw;
  height: 20px;
  z-index: 5;
  background-color: rgb(255, 255, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/welcomeComponents/TopContent.vue